import { call, put, takeEvery } from "redux-saga/effects";
import {  toast } from 'react-toastify';
import store from "redux/store";
import { GET_ADDTAG_FAILED, GET_ADDTAG_REQUESTED, GET_ADDTAG_SUCCESS, GET_RATING_FAILED, GET_RATING_REQUESTED, GET_RATING_SUCCESS, GET_TAG_FAILED, GET_TAG_REQUESTED, GET_TAG_SUCCESS, GET_UPDATETAG_FAILED, GET_UPDATETAG_REQUESTED, GET_UPDATETAG_SUCCESS } from "resources/actionTypes";
import { addTagApi, ratingApi, tagApi, updateTagApi } from "services/TagService";
import { getTag } from "redux/actions/UserTag";
import { onLoaderTrigger } from "redux/actions/commonAction";

function* fetchTag(action) {
  try {
    const payload = action.payload || {}
    const userTag = yield call(tagApi,payload);
    yield put({ type: GET_TAG_SUCCESS, userTag: userTag });
  } catch (e) {
    yield put({ type: GET_TAG_FAILED, message: e.message });
    toast.error(e.message || 'Get Tag Failed')
  }
}

export function* tagSaga() {
  yield takeEvery(GET_TAG_REQUESTED, fetchTag);
}

function* fetchAddTag(action) {
  const payload = action.payload || {}
  store.dispatch(onLoaderTrigger(true));
  const userAddTag = yield call(addTagApi, payload.userAddTag);
  if(userAddTag.success){
    yield put({ type: GET_ADDTAG_SUCCESS, userAddTag: userAddTag });
    toast.success(userAddTag.message);
    store.dispatch(onLoaderTrigger(false));
    store.dispatch(getTag(payload.userAddTag.type));
  }else{
    store.dispatch(onLoaderTrigger(false));
    yield put({ type: GET_ADDTAG_FAILED, message: userAddTag.message });
      toast.error(userAddTag.message || 'Add Tag failed');
  }
}
export function* addTagSaga() {
  yield takeEvery(GET_ADDTAG_REQUESTED, fetchAddTag);
}

function* fetchUpdateTag(action) {
  const payload = action.payload || {}
  store.dispatch(onLoaderTrigger(true));
  const userUpdateTag = yield call(updateTagApi, payload.userUpdateTag);
  if(userUpdateTag.success){
    yield put({ type: GET_UPDATETAG_SUCCESS, userUpdateTag: userUpdateTag });
    toast.success(userUpdateTag.message);
    store.dispatch(onLoaderTrigger(false));
    store.dispatch(getTag(payload.userUpdateTag.type));
  }else{
    store.dispatch(onLoaderTrigger(false));
    yield put({ type: GET_UPDATETAG_FAILED, message: userUpdateTag.message });
      toast.error(userUpdateTag.message || 'Update Tag failed');
  }
}
export function* updateTagSaga() {
  yield takeEvery(GET_UPDATETAG_REQUESTED, fetchUpdateTag);
}

function* fetchRating(action) {
  try {
    const payload = action.payload || {}
    const userRating = yield call(ratingApi,payload);
    yield put({ type: GET_RATING_SUCCESS, userRating: userRating });
  } catch (e) {
    yield put({ type: GET_RATING_FAILED, message: e.message });
    toast.error(e.message || 'Get Rating Failed')
  }
}

export function* ratingSaga() {
  yield takeEvery(GET_RATING_REQUESTED, fetchRating);
}